import { Koala } from 'assets/images';

const getCertificateName = (
  id: number,
  isEmeritus: boolean,
  isLongName: boolean,
) => {
  if (isEmeritus) {
    return 'Atlassian Certified Expert Emeritus';
  }

  if (isLongName) {
    return new Array(50).fill('Certificate').join(' ');
  }

  return `Certificate ${id}`;
};
const getMockedCertmetricsCertificatesEdge = (
  id: number,
  isEmeritus: boolean,
  isLongName: boolean,
) => ({
  __typename: 'UnifiedLearningCertificationEdge',
  cursor: `${id}`,
  node: {
    __typename: 'UnifiedLearningCertification',
    name: getCertificateName(id, isEmeritus, isLongName),
    activeDate: '2024-02-02',
    imageUrl: Koala,
    publicUrl: 'https://example.com',
    nameAbbr: isEmeritus ? 'ACP-EE' : `TEST-${id}`,
    status: 'ACTIVE',
  },
});

export const getMockedCertmetricsCertificatesEdges = ({
  count,
  withEmeritus,
}: {
  count: number;
  withEmeritus: boolean;
}) => {
  if (count === 0) {
    return [];
  }

  return new Array(count).fill(null).map((_, index) => {
    const isEmeritus = withEmeritus && index === 0;
    const isLongName = index === 1;

    return getMockedCertmetricsCertificatesEdge(index, isEmeritus, isLongName);
  });
};
